import React from "react";
import ICONS from "../../constants/icons";
import STRINGS from "../../constants/strings";

import {
  PageContainer,
  SubTitle,
  Title,
  WholeWrapper,
  AnimationWrapper,
  LogoWrapper,
} from "./components";

const LandingPage = ({ onTouch }) => {
  return (
    <WholeWrapper onClick={onTouch}>
      <PageContainer>
        <Title>{STRINGS.hello_nice_to_meet}</Title>
        <AnimationWrapper>
          <LogoWrapper>
            <ICONS.LandingPageLogo />
          </LogoWrapper>
        </AnimationWrapper>
        <SubTitle>{STRINGS.touch_to_start}</SubTitle>

      </PageContainer>
    </WholeWrapper>
  );
};

export default LandingPage;
